import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TError, TTermsAcceptanceResponse } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key (non-hook version)
 */
export const getSpaceTermsAcceptanceQueryKey = (spaceId: string) => [ENTITY, 'feed-terms', 'acceptance', spaceId];

/**
 * Query key (hook version, kept for symmetry with the rest of the package)
 */
export const useGetSpaceTermsAcceptanceQueryKey = (spaceId: string) => getSpaceTermsAcceptanceQueryKey(spaceId);

/**
 * Fetch the current user's T&C acceptance state for a feed space.
 *
 * Backend response signals:
 * - `requiresAcceptance: false` → space has no terms; do not gate.
 * - `accepted: false` → the user hasn't accepted, OR has accepted a stale version
 *    (server compares stored vs current `terms.version`).
 *
 * @param spaceId - Space ID (UUID)
 */
export const useGetSpaceTermsAcceptance = (spaceId: string) => {
  return useQuery<TTermsAcceptanceResponse, TError>({
    queryKey: useGetSpaceTermsAcceptanceQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TTermsAcceptanceResponse>(`/community-hub/spaces/${spaceId}/terms-acceptance`);
      return res.data;
    },
    enabled: !!spaceId,
    staleTime: 60 * 1000,
  });
};
